import { Component, EventEmitter, Input, Output } from '@angular/core';

import { RanglistListModel, ResultProvider } from '../../providers/result/result';
import { App, NavController, ModalController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { LoaderProvider } from '../../providers/loader/loader';
import { ResultDetailsPage } from '../../pages/results/result-details/result-details';
import { NewsController } from '../../providers/news/news-contoller';
import { ConfigProvider } from '../../providers/config/config';
import { DeeplinkProvider } from '../../providers/deeplink/deeplink';
import { AppDetectorProvider } from '../../providers/detector/detector';
import { EditAthleteData } from '../../pages/edit-athlete-data/edit-athlete-data';

/**
 * Generated class for the ResultRanglistListItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'result-ranglist-list-item',
  templateUrl: 'result-ranglist-list-item.html'
})
export class ResultRanglistListItemComponent {

  @Input("distance") distance: boolean = false;

  @Input("result") result: RanglistListModel;

  @Input('userSection') userSection: boolean = false;

  // TODO: specify the type
  @Input('editPageIsOpen') editPageIsOpen;

  @Output() click = new EventEmitter<any>();


  isThurnauApp: boolean = false;

  constructor(
    private navCtrl: NavController,
    private translate: TranslateService,
    private deeplinkService: DeeplinkProvider,
    private loadingCtrl: LoaderProvider,
    private resultService: ResultProvider,
    private config: ConfigProvider,
    public appDetector: AppDetectorProvider
  ) {
    new Promise<any>(async (resolve, reject) => {
      this.isThurnauApp = (await this.config.config).appId.includes('thurnau') ? true : false;
      if (!this.isThurnauApp)
        this.isThurnauApp = this.deeplinkService.getCurrentRequest().includes('thurnau') ? true : false;
      console.log(this.result);
    })
  }

  openResult() {
    NewsController.getInstance().isAllowed = false;

    let loader = this.loadingCtrl.create({ content: this.translate.instant("GLOBAL_LOADING") });
    loader.present();
    if(this.appDetector.isLeaderBoardApp()){
      this.navCtrl.push(ResultDetailsPage, { result: this.result, userSection: this.userSection, userLid: this.result.lid });
        loader.dismiss();
    }else{
      this.resultService.getResult(this.result.id, this.result.cid).then(data => {

        this.navCtrl.push(ResultDetailsPage, { result: data, userSection: this.userSection, userLid: this.result.lid });
        console.log(data)
        loader.dismiss();
      });
    }
  }

}



// WEBPACK FOOTER //
// /src/components/result-ranglist-list-item/result-ranglist-list-item.ts